import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-p2-subscriptions-edit',
  templateUrl: './p2-subscriptions-edit.component.html',
  styleUrls: ['./p2-subscriptions-edit.component.css']
})
export class P2SubscriptionsEditComponent implements OnInit {
    p2SubscriptionKeyno;

    public selectedBgP2SubscriptionsEdit: string = 'USERGROUPS';

    public videoUrlButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fa fa-window-restore', onClick: () => window.open(this.menu!.video_url) }];

    public menu?: Menu;

    public itemsListSubscriptionUserGroups: Item[] = [];

    public gridUsers?: GridOptions;

    public gridWebPages?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.p2SubscriptionKeyno = this.stateService.getStateParams()['p2_subscription_keyno'];
    }

    private async loadMenu() {
        if (!!this.p2SubscriptionKeyno) {
            this.menu = (await this.datatask.Post(110, { p2_subscription_keyno: this.p2SubscriptionKeyno }))[0];
        }
    }

    private async loadSubscriptionUserGroups() {
        if (!this.menu) return;

        return this.itemsListSubscriptionUserGroups = await this.datatask.Post(111, {
            argtype: 'p2_subscription_keyno',
            argvalue: this.menu.p2_subscription_keyno
        });
    }

    private loadGridUsers() {
        if (!this.menu) return;

        if (!this.gridUsers) {
            this.gridUsers = new Grid()
                .setRememberId('w_p2subscriptions_edit_users_grid')
                .setLoadDataFunction({
                    method: 2873,
                    parameters: { p2_subscription_keyno: this.menu.p2_subscription_keyno }
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.gridUsers?.gridfunc?.read();
        }
    }

    private loadGridWebPages() {
        if (!this.menu) return;

        if (!this.gridWebPages) {
            this.gridWebPages = new Grid()
                .setRememberId('w_p2subscriptions_edit_webpages_grid')
                .setLoadDataFunction({
                    method: 2874,
                    parameters: { p2_subscription_keyno: this.menu.p2_subscription_keyno }
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.gridWebPages?.gridfunc?.read();
        }
    }

    private async init() {
        await this.loadMenu();
        this.loadSubscriptionUserGroups();
        this.loadGridUsers();
        this.loadGridWebPages();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    p2_subscription_keyno: string;
    subscription_heading: string;
    subscription_description: string;
    price_eur: string;
    price_locval: string;
    nbr_of_lisences: string;
    nbr_of_lisences_subtext: string;
    lisence_amount_locval: string;
    video_url: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('p2SubscriptionsEdit', {
//        templateUrl: 'views/components/views/p2SubscriptionsEdit/p2SubscriptionsEdit.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'p2SubscriptionsEditService', 'subscriptionUsergroupService', 'ttGridFactory', function ($stateParams, p2SubscriptionsEditService, subscriptionUsergroupService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let p2SubscriptionKeyno = $stateParams.p2_subscription_keyno;

//            vm.model = {
//                bgP2SubscriptionsEdit: {
//                    selected: 'USERGROUPS',
//                    buttons: [
//                        { id: 'USERGROUPS', label: 'bg_p2subscriptions_edit_usergroups', color: 'primary', onClick: () => vm.model.bgP2SubscriptionsEdit.selected = 'USERGROUPS' },
//                        { id: 'USERS', label: 'bg_p2subscriptions_edit_users', color: 'primary', onClick: () => vm.model.bgP2SubscriptionsEdit.selected = 'USERS' },
//                        { id: 'WEBPAGES', label: 'bg_p2subscriptions_edit_webpages', color: 'primary', onClick: () => vm.model.bgP2SubscriptionsEdit.selected = 'WEBPAGES' }
//                    ]
//                },
//                videoUrlButtons: [
//                    { id: 'goto', icon: 'fa fa-window-restore', color: 'primary', type: 'primary', onClick: () => window.open(vm.model.menu.video_url) }
//                ],
//                menu: {},
//                itemsListSubscriptionUserGroups: [],
//                gridUsersReady: false,
//                gridWebPagesReady: false
//            };

//            vm.gridUsers = new ttGridFactory({
//                rememberId: 'w_p2subscriptions_edit_users_grid',
//                kendo: {
//                    height: null,
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });

//            vm.gridWebPages = new ttGridFactory({
//                rememberId: 'w_p2subscriptions_edit_webpages_grid',
//                kendo: {
//                    height: null,
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await p2SubscriptionsEditService.getSubscriptionsEdit({ p2_subscription_keyno: p2SubscriptionKeyno }))[0];
//            }

//            async function loadSubscriptionUserGroups() {
//                vm.model.itemsListSubscriptionUserGroups = await subscriptionUsergroupService.listSubscriptionUserGroups({
//                    argtype: 'p2_subscription_keyno',
//                    argvalue: p2SubscriptionKeyno
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGridUsers() {
//                vm.gridUsers.dataTask.loadData = {
//                    method: 2873,
//                    parameters: { p2_subscription_keyno: p2SubscriptionKeyno }
//                };

//                vm.model.gridUsersReady = true;

//                if (vm.gridUsers.gridfunc !== null) vm.gridUsers.gridfunc.read();
//            }

//            async function loadGridWebPages() {
//                vm.gridWebPages.dataTask.loadData = {
//                    method: 2874,
//                    parameters: { p2_subscription_keyno: p2SubscriptionKeyno }
//                };

//                vm.model.gridWebPagesReady = true;

//                if (vm.gridWebPages.gridfunc !== null) vm.gridWebPages.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region BUTTON GROUP SINGLE FUNCTION

//            vm.selectBgP2SubscriptionsEdit = function (value) {
//                vm.model.bgP2SubscriptionsEdit.selected = value;
//            }

//            // #endregion BUTTON GROUP SINGLE FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadMenu();
//                loadSubscriptionUserGroups();
//                loadGridUsers();
//                loadGridWebPages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
